import { MEDICATION_PLAN_KEY } from './utils';

export type Choice = {
    key: string,
    preferenceKey?: string,
    icon?: JSX.Element,
    ctaIcon?: {
        position: 'left' | 'right',
        element: JSX.Element
    },
    title?: string,
    subtitle?: string,
    action?: string,
    effect?: string,
    legacyTitle?: string,
    padding?: string,
    orientation?: string,
    jump?: number
};

export type Field = {
    key: string,
    title: string,
    gridArea: string,
    placeholder?: string
}

export type Form = {
    fields: Field[],
    value: { [key: string]: string }
}

export const MAT_BOOLEAN: Choice[] = [
    {
        icon: null,
        key: 'Yes',
        title: '',
        subtitle: 'Yes'
    },
    {
        icon: null,
        key: 'No',
        title: '',
        subtitle: 'No'
    },
];

export const MAT_CONDITIONAL_BOOLEAN: Choice[] = [
    {
        icon: null,
        key: 'Yes',
        subtitle: 'Yes',
        jump: 1
    },
    {
        icon: null,
        key: 'No',
        subtitle: 'No',
        jump: 2
    }
];

export const BOOLEAN: Choice[] = [
    {
        icon: null,
        key: 'true',
        title: '',
        subtitle: 'Yes'
    },
    {
        icon: null,
        key: 'false',
        title: '',
        subtitle: 'No'
    },
];

export const BOOLEAN_2: Choice[] = [
    {
        icon: null,
        key: 'true',
        title: 'Yes'
    },
    {
        icon: null,
        key: 'false',
        title: 'No'
    },
];

export const CONDITIONAL_BOOLEAN: Choice[] = [
    {
        icon: null,
        key: 'true',
        subtitle: 'Yes',
        jump: 1
    },
    {
        icon: null,
        key: 'false',
        subtitle: 'No',
        jump: 2
    }
];

export const GOAL_CHOICES: Choice[] = [
    {
        key: 'health',
        icon: (
            <svg
                style={{
                    width: '100%',
                    height: '100%'
                }}
                width="17"
                height="16"
                viewBox="0 0 17 16"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g clipPath="url(#clip0_4087_13)">
                    <g clipPath="url(#clip1_4087_13)">
                        <path d="M9.84954 11.531C9.80153 11.595 9.73889 11.6465 9.66686 11.6812C9.59483 11.7159 9.51552 11.7329 9.43559 11.7306C9.35566 11.7284 9.27743 11.707 9.20747 11.6682C9.13752 11.6295 9.07787 11.5746 9.03354 11.508L6.56454 7.804L5.99454 8.757C5.95017 8.83105 5.88738 8.89235 5.81229 8.93493C5.7372 8.97752 5.65236 8.99993 5.56604 9H2.47754C4.66254 12.317 8.49954 15.482 8.49954 15.482C8.49954 15.482 12.3365 12.317 14.5215 9H11.7495L9.84954 11.531Z" />
                        <path d="M15.59 7C15.841 6.41698 15.9801 5.79194 16 5.1575C16.0118 4.27358 15.7365 3.40969 15.2155 2.69556C14.6945 1.98143 13.9559 1.4556 13.1105 1.19704C12.2652 0.938482 11.3588 0.961148 10.5275 1.26164C9.6961 1.56212 8.98467 2.12422 8.5 2.8635C8.12576 2.3029 7.62059 1.84189 7.0282 1.52034C6.4358 1.19879 5.77399 1.02637 5.1 1.018C4.00772 1.02435 2.96258 1.46377 2.19392 2.23983C1.42526 3.0159 0.995876 4.06521 1 5.1575C1.02008 5.79197 1.15934 6.41701 1.4105 7H0.5V8H5.283L6.5225 5.9345L9.476 10.365L11.25 8H16.5V7H15.59Z" />
                    </g>
                </g>
                <defs>
                    <clipPath id="clip0_4087_13">
                        <rect
                            width="16"
                            height="16"
                            fill="white"
                            transform="translate(0.5)"
                        />
                    </clipPath>
                    <clipPath id="clip1_4087_13">
                        <rect
                            width="16"
                            height="16"
                            fill="white"
                            transform="translate(0.5)"
                        />
                    </clipPath>
                </defs>
            </svg>
        ),
        subtitle: 'Improve Health and Wellness',
        action: 'improve your overall health',
        effect: 'improved health and wellness',
        legacyTitle: 'Improve overall health and wellness',
        padding: '20px'
    },
    {
        key: 'healthspan',
        icon: (
            <svg
                style={{
                    width: '100%',
                    height: '100%'
                }}
                width="17"
                height="16"
                viewBox="0 0 17 16"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g clipPath="url(#clip0_4087_354)">
                    <g clipPath="url(#clip1_4087_354)">
                        <path d="M13.8899 7.972C11.5729 6.75 8.15291 7.888 6.58991 9.133C6.53591 9.053 6.47691 8.969 6.41491 8.879C5.9788 8.33031 5.64052 7.71058 5.41491 7.047C5.31688 6.42082 5.26175 5.78869 5.24991 5.155C5.40408 5.15441 5.55794 5.14103 5.70991 5.115C6.38384 4.91321 6.98501 4.52077 7.44091 3.985C7.58535 3.76978 7.6638 3.51706 7.66664 3.25788C7.66949 2.9987 7.59659 2.74433 7.45691 2.526C7.57791 2.18272 7.6332 1.81973 7.61991 1.456C7.62037 1.27785 7.58248 1.10168 7.5088 0.939484C7.43512 0.777284 7.32738 0.632849 7.19291 0.515997C7.16592 0.494082 7.13677 0.474982 7.10591 0.458997C6.37644 0.0866032 5.55672 -0.0724875 4.74091 -3.12132e-06C2.75191 -3.12132e-06 1.58091 4.421 1.05891 7.059C0.358907 10.627 1.53491 14.036 2.19191 14.706C3.26291 15.796 5.63391 15.63 6.19191 15.575C7.12676 15.8708 8.10137 16.0219 9.08191 16.023C9.35191 16.023 9.62091 16.012 9.88891 15.988C11.5654 15.9847 13.2104 15.5324 14.6529 14.678C15.1362 14.3248 15.526 13.859 15.7886 13.3211C16.0512 12.7831 16.1786 12.1893 16.1599 11.591C16.1145 10.846 15.8829 10.1244 15.4863 9.4921C15.0897 8.85984 14.5408 8.33718 13.8899 7.972ZM13.3129 12.05C12.2293 12.6938 10.9923 13.034 9.73191 13.035C9.13888 13.0345 8.54826 12.9596 7.97391 12.812C7.78517 12.7592 7.62458 12.6347 7.5265 12.465C7.42843 12.2953 7.40067 12.094 7.44915 11.9041C7.49763 11.7143 7.61852 11.5509 7.78593 11.449C7.95334 11.3471 8.15397 11.3148 8.34491 11.359C9.05086 11.5418 9.78603 11.5828 10.5079 11.4799C11.2299 11.3769 11.9242 11.1319 12.5509 10.759C12.6358 10.7049 12.7307 10.6684 12.83 10.6517C12.9292 10.635 13.0309 10.6385 13.1288 10.662C13.2267 10.6854 13.3189 10.7283 13.3998 10.7881C13.4808 10.8479 13.5489 10.9234 13.6001 11.0101C13.6512 11.0968 13.6844 11.1929 13.6977 11.2927C13.7109 11.3925 13.7039 11.494 13.6771 11.591C13.6503 11.688 13.6043 11.7787 13.5417 11.8575C13.4791 11.9364 13.4013 12.0018 13.3129 12.05Z" />
                    </g>
                </g>
                <defs>
                    <clipPath id="clip0_4087_354">
                        <rect
                            width="16"
                            height="16"
                            fill="white"
                            transform="translate(0.5)"
                        />
                    </clipPath>
                    <clipPath id="clip1_4087_354">
                        <rect
                            width="16"
                            height="16"
                            fill="white"
                            transform="translate(0.5)"
                        />
                    </clipPath>
                </defs>
            </svg>
        ),
        subtitle: 'Slow Down Effects of Aging',
        action: 'slow down the effects alcohol has on aging',
        effect: 'reduced effects of aging',
        legacyTitle: 'Slow down effects of aging',
        padding: '20px'
    },
    {
        key: 'weight',
        icon: (
            <svg
                style={{
                    width: '100%',
                    height: '100%'
                }}
                width="17"
                height="16"
                viewBox="0 0 17 16"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path d="M10.0951 6.42086C10.0951 6.42086 10.7853 2.36098 7.96892 0.598434C7.92696 1.296 7.73831 1.97687 7.41531 2.59657C7.09231 3.21627 6.64221 3.76086 6.09441 4.19478C4.89162 5.2523 2.62945 7.63013 2.65351 10.1652C2.64487 11.2489 2.93924 12.3135 3.50342 13.2388C4.0676 14.1641 4.87913 14.9134 5.84645 15.402C5.88101 14.9127 6.01289 14.4352 6.23436 13.9975C6.45583 13.5598 6.76244 13.1707 7.13621 12.853C7.45294 12.6094 7.718 12.3052 7.91593 11.9581C8.11386 11.611 8.24069 11.228 8.28904 10.8314C9.11705 11.2716 9.81665 11.9191 10.3194 12.7107C10.8221 13.5023 11.1108 14.4108 11.1572 15.3474V15.3594C12.0702 14.9412 12.8498 14.2786 13.4095 13.4448C13.9693 12.611 14.2875 11.6386 14.3289 10.6352C14.5287 8.25373 13.2242 5.01545 12.0667 3.95699C11.6297 4.93259 10.9511 5.78061 10.0951 6.42086Z" />
            </svg>
        ),
        subtitle: 'Lose Weight and Improve Fitness',
        action: 'accelerate weight loss and improve fitness levels',
        effect: 'weight loss and improved fitness',
        legacyTitle: 'Lose weight by cutting alcohol calories (and drunchies)',
        padding: '10px'
    },
    {
        key: 'sleep',
        icon: (
            <svg
                style={{
                    width: '100%',
                    height: '100%'
                }}
                width="17"
                height="16"
                viewBox="0 0 17 16"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g clipPath="url(#clip0_4087_84)">
                    <g clipPath="url(#clip1_4087_84)">
                        <path d="M6.5 0C3 0.9 0.5 4.1 0.5 7.9C0.5 12.4 4.1 16 8.6 16C12.4 16 15.5 13.5 16.5 10C10.4 11.7 4.8 6.1 6.5 0Z" />
                    </g>
                </g>
                <defs>
                    <clipPath id="clip0_4087_84">
                        <rect
                            width="16"
                            height="16"
                            fill="white"
                            transform="translate(0.5)"
                        />
                    </clipPath>
                    <clipPath id="clip1_4087_84">
                        <rect
                            width="16"
                            height="16"
                            fill="white"
                            transform="translate(0.5)"
                        />
                    </clipPath>
                </defs>
            </svg>
        ),
        subtitle: 'Improve Sleep Quality',
        action: 'improve the quality of your sleep',
        effect: 'improved sleep',
        legacyTitle: 'Sleep better and increase energy',
        padding: '20px'
    },
    {
        key: 'hangover',
        icon: (
            <svg
                style={{
                    width: '100%',
                    height: '100%'
                }}
                width="17"
                height="16"
                viewBox="0 0 17 16"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g clipPath="url(#clip0_4087_5391)">
                    <g clipPath="url(#clip1_4087_5391)">
                        <path d="M8.5 0C8.83987 0 9.11538 0.275517 9.11538 0.615385V2.46154C9.11538 2.80141 8.83987 3.07692 8.5 3.07692C8.16013 3.07692 7.88462 2.80141 7.88462 2.46154V0.615385C7.88462 0.275517 8.16013 0 8.5 0Z" />
                        <path d="M4.80769 8C4.80769 5.96079 6.46079 4.30769 8.5 4.30769C10.5392 4.30769 12.1923 5.96079 12.1923 8C12.1923 10.0392 10.5392 11.6923 8.5 11.6923C6.46079 11.6923 4.80769 10.0392 4.80769 8Z" />
                        <path d="M14.1569 3.21341C14.3972 2.97308 14.3972 2.58344 14.1569 2.34312C13.9166 2.1028 13.5269 2.1028 13.2866 2.34312L11.9812 3.64855C11.7409 3.88887 11.7409 4.27851 11.9812 4.51883C12.2215 4.75916 12.6111 4.75916 12.8515 4.51883L14.1569 3.21341Z" />
                        <path d="M16.5 8C16.5 8.33987 16.2245 8.61538 15.8846 8.61538H14.0385C13.6986 8.61538 13.4231 8.33987 13.4231 8C13.4231 7.66013 13.6986 7.38462 14.0385 7.38462H15.8846C16.2245 7.38462 16.5 7.66013 16.5 8Z" />
                        <path d="M13.2865 13.6568C13.5268 13.8971 13.9165 13.8971 14.1568 13.6568C14.3971 13.4165 14.3971 13.0269 14.1568 12.7865L12.8514 11.4811C12.6111 11.2408 12.2214 11.2408 11.9811 11.4811C11.7408 11.7214 11.7408 12.1111 11.9811 12.3514L13.2865 13.6568Z" />
                        <path d="M8.5 12.9231C8.83987 12.9231 9.11538 13.1986 9.11538 13.5385V15.3846C9.11538 15.7245 8.83987 16 8.5 16C8.16013 16 7.88462 15.7245 7.88462 15.3846V13.5385C7.88462 13.1986 8.16013 12.9231 8.5 12.9231Z" />
                        <path d="M5.01898 12.3514C5.2593 12.1111 5.2593 11.7214 5.01898 11.4811C4.77865 11.2408 4.38901 11.2408 4.14869 11.4811L2.84326 12.7865C2.60294 13.0269 2.60294 13.4165 2.84326 13.6568C3.08359 13.8972 3.47323 13.8972 3.71355 13.6568L5.01898 12.3514Z" />
                        <path d="M3.57692 8C3.57692 8.33987 3.30141 8.61538 2.96154 8.61538H1.11538C0.775517 8.61538 0.5 8.33987 0.5 8C0.5 7.66013 0.775517 7.38462 1.11538 7.38462H2.96154C3.30141 7.38462 3.57692 7.66013 3.57692 8Z" />
                        <path d="M4.1486 4.51883C4.38892 4.75915 4.77856 4.75915 5.01888 4.51883C5.25921 4.2785 5.25921 3.88886 5.01888 3.64854L3.71346 2.34311C3.47313 2.10279 3.08349 2.10279 2.84317 2.34311C2.60285 2.58344 2.60285 2.97308 2.84317 3.2134L4.1486 4.51883Z" />
                    </g>
                </g>
                <defs>
                    <clipPath id="clip0_4087_5391">
                        <rect
                            width="16"
                            height="16"
                            fill="white"
                            transform="translate(0.5)"
                        />
                    </clipPath>
                    <clipPath id="clip1_4087_5391">
                        <rect
                            width="16"
                            height="16"
                            fill="white"
                            transform="translate(0.5)"
                        />
                    </clipPath>
                </defs>
            </svg>
        ),
        subtitle: 'Avoid Hangovers',
        action: 'eliminate hangovers and other next day effects',
        effect: 'fewer hangovers',
        legacyTitle: 'Avoid hangovers and other negative next-day effects',
        padding: '20px'
    },
    {
        key: 'blackout',
        icon: (
            <svg
                style={{
                    width: '100%',
                    height: '100%'
                }}
                width="17"
                height="16"
                viewBox="0 0 17 16"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g clipPath="url(#clip0_4606_1343)">
                    <g clipPath="url(#clip1_4606_1343)">
                        <path d="M16.5 7.55188C16.5 6.89088 16.0723 6.30765 15.4502 6.0938L15.2558 6.03547L15.2363 5.82162C15.1586 4.79125 14.2837 3.95528 13.2339 3.95528H13.02L12.9423 3.74143C12.7284 3.19708 12.223 2.8277 11.6397 2.8277C11.4453 2.8277 11.2509 2.88602 11.0565 2.96378L10.9593 3.00267C10.551 3.23596 10.2594 3.6831 10.2594 4.20801C10.2594 4.38298 10.1233 4.51907 9.94836 4.51907C9.77339 4.51907 9.6373 4.38298 9.6373 4.20801C9.6373 3.56646 9.94836 3.00267 10.4149 2.63329C10.2011 2.47776 9.92892 2.39999 9.65674 2.39999C9.32624 2.39999 9.01519 2.51664 8.76245 2.73049L8.60693 2.86658L8.41251 2.76937C8.10146 2.61385 7.73208 2.51664 7.38214 2.51664C6.7017 2.51664 6.06015 2.8277 5.65188 3.37205L5.5158 3.56646L5.30194 3.48869C5.12697 3.43037 4.97145 3.39149 4.79648 3.39149C4.27157 3.39149 3.78554 3.6831 3.55225 4.16913L3.45504 4.36354L3.20231 4.3441H3.16343C2.23025 4.3441 1.47205 5.1023 1.47205 6.03547C1.47205 6.96864 2.23026 7.70741 3.14399 7.72685C3.28007 7.68796 3.41616 7.74629 3.49392 7.86293C3.57169 7.99902 3.53281 8.19343 3.37728 8.29064C3.22175 8.38784 3.1051 8.54337 3.06622 8.71834C3.02734 8.89331 3.04678 9.08772 3.14399 9.24325C3.22175 9.37934 3.18287 9.57375 3.02734 9.67095C2.98846 9.69039 2.93013 9.70983 2.87181 9.70983C2.75516 9.70983 2.65796 9.65151 2.59964 9.55431C2.40522 9.24325 2.36634 8.89331 2.44411 8.54337C2.46355 8.44617 2.50243 8.34896 2.56075 8.25176C1.80255 8.05734 1.18044 7.47411 0.947145 6.73535C0.655529 7.14361 0.5 7.64908 0.5 8.15455C0.5 9.55431 1.64702 10.6819 3.02734 10.6819C3.20231 10.6819 3.37728 10.6624 3.53281 10.6236L3.61057 10.6041L3.68834 10.643C3.84386 10.7013 4.01883 10.7402 4.1938 10.7597C4.1938 10.0015 4.60207 9.26269 5.34083 8.91275C5.49635 8.83499 5.69077 8.91275 5.76853 9.06828C5.84629 9.22381 5.76853 9.41822 5.613 9.49598C4.91312 9.82648 4.62151 10.6624 4.952 11.3429C4.97145 11.3623 4.97145 11.3818 4.97145 11.4012C5.39915 12.2566 6.13791 12.6843 7.18773 12.6843C7.76318 12.6843 8.70607 12.9254 9.57703 13.3142L9.5712 13.3103L11.7953 14.0646C13.1561 14.4146 14.517 13.598 14.8669 12.2372C14.9253 11.9456 14.9642 11.6539 14.9253 11.3623C14.8281 10.3125 14.0699 9.43766 13.0395 9.18493C12.8645 9.14604 12.7673 8.97107 12.8062 8.79611C12.8451 8.62114 13.02 8.52393 13.195 8.56281C14.342 8.85443 15.2363 9.7876 15.4891 10.9346C16.0917 10.6624 16.4806 10.0598 16.4806 9.39878C16.4806 9.10716 16.4222 8.85443 16.2861 8.60169L16.2278 8.44617L16.3056 8.29064C16.4417 8.07679 16.5 7.80461 16.5 7.55188ZM7.55905 4.48991C8.66719 4.48991 9.58092 5.3842 9.58092 6.51178C9.58092 6.64787 9.46428 6.76451 9.32819 6.76451C9.1921 6.76451 9.07546 6.64787 9.07546 6.51178C9.07546 5.67581 8.39502 4.99538 7.55905 4.99538C7.42296 4.99538 7.30632 4.87873 7.30632 4.74264C7.30632 4.60656 7.42296 4.48991 7.55905 4.48991ZM5.45942 5.61749C5.01227 6.25905 4.27351 6.60898 3.53475 6.60898C3.14593 6.60898 2.73767 6.51178 2.36829 6.29793C2.25164 6.22016 2.21276 6.06463 2.27108 5.94799C2.34885 5.83134 2.50437 5.79246 2.62102 5.85078C3.49587 6.35625 4.62345 6.06463 5.14836 5.17035C5.05115 4.95649 4.99283 4.7232 4.99283 4.48991C4.99283 4.35382 5.10948 4.23717 5.24556 4.23717C5.38165 4.23717 5.4983 4.35382 5.4983 4.48991C5.47886 5.03426 5.926 5.50084 6.47035 5.52028C6.60644 5.52028 6.72309 5.63693 6.72309 5.77302C6.72309 5.94799 6.60644 6.04519 6.47035 6.04519C6.08153 6.04519 5.73159 5.87022 5.45942 5.61749ZM6.70364 10.5166C6.66476 10.5944 6.56756 10.6333 6.48979 10.6333C6.45091 10.6333 6.39259 10.6138 6.35371 10.5944C6.23706 10.5166 6.19818 10.3611 6.27594 10.2445C6.70364 9.56403 6.48979 8.66974 5.80936 8.24203C5.69271 8.16427 5.65383 8.00874 5.73159 7.8921C5.80936 7.77545 5.96488 7.73657 6.08153 7.81433C6.99526 8.39756 7.26744 9.60291 6.70364 10.5166ZM8.41446 8.80583C7.57849 8.417 6.99526 7.61992 6.87861 6.70619C6.85917 6.5701 6.95638 6.43402 7.09247 6.41457C7.22855 6.39513 7.36464 6.49234 7.38408 6.62843C7.50073 7.46439 8.06452 8.16427 8.8616 8.43644C9.42539 8.63086 10.0281 8.59197 10.5724 8.33924C11.1168 8.08651 11.5056 7.61992 11.7 7.05613C11.7389 6.92004 11.8944 6.86172 12.0305 6.9006C12.1666 6.93948 12.2249 7.09501 12.186 7.2311C11.9527 7.93098 11.4473 8.47533 10.7863 8.78638C10.4169 8.96135 10.0086 9.05856 9.60036 9.05856C9.5226 9.05856 9.44484 9.05856 9.34763 9.03912C9.56148 9.38906 9.69757 9.79732 9.69757 10.2445C9.69757 10.3806 9.58092 10.4972 9.44484 10.4972C9.30875 10.4972 9.1921 10.4 9.1921 10.2639C9.1921 9.68067 8.90049 9.13632 8.41446 8.80583ZM12.4582 11.3332C11.9722 12.033 11.1945 12.4219 10.3974 12.4219C9.91142 12.4219 9.42539 12.2858 8.99769 11.9942C8.88104 11.9164 8.8616 11.7609 8.93937 11.6442C9.01713 11.5276 9.17266 11.5081 9.28931 11.5859C9.73645 11.8775 10.2614 11.9942 10.7863 11.897C11.3112 11.7997 11.7583 11.5081 12.0694 11.061C12.1277 10.9443 12.2832 10.9055 12.3999 10.9832C12.5165 11.061 12.536 11.2165 12.4582 11.3332ZM13.7413 7.60048C13.6052 7.60048 13.4886 7.48383 13.4886 7.34775C13.4886 6.20072 12.5554 5.26755 11.4084 5.26755C11.2723 5.26755 11.1556 5.1509 11.1556 5.01482C11.1556 4.87873 11.2723 4.76208 11.4084 4.76208C12.8276 4.76208 13.994 5.92855 13.994 7.34775C13.994 7.48383 13.8774 7.60048 13.7413 7.60048Z" />
                    </g>
                </g>
                <defs>
                    <clipPath id="clip0_4606_1343">
                        <rect
                            width="16"
                            height="16"
                            fill="white"
                            transform="translate(0.5)"
                        />
                    </clipPath>
                    <clipPath id="clip1_4606_1343">
                        <rect
                            width="16"
                            height="11.7463"
                            fill="white"
                            transform="translate(0.5 2.39999)"
                        />
                    </clipPath>
                </defs>
            </svg>
        ),
        subtitle: 'Stop Blacking or graying Out',
        action: 'eliminate occurrences of blacking (or graying) out',
        effect: 'eliminated blackouts',
        legacyTitle: 'Stop blacking (or graying) out',
        padding: '20px'
    },
    {
        key: 'money',
        icon: (
            <svg
                style={{
                    width: '100%',
                    height: '100%'
                }}
                width="17"
                height="16"
                viewBox="0 0 17 16"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path d="M10.326 8.76896C11.1527 9.22177 12.1049 9.39172 13.0372 9.25288C13.9695 9.11405 14.8308 8.67405 15.4896 8.00001C15.0874 7.58828 14.6068 7.26116 14.0762 7.03791C13.5457 6.81465 12.9758 6.69977 12.4002 6.70001C11.6138 6.70126 10.8412 6.90628 10.1577 7.29509C9.47422 7.68389 8.90314 8.2432 8.50019 8.91846C8.09724 8.2432 7.52617 7.68389 6.84266 7.29509C6.15915 6.90628 5.38654 6.70126 4.60019 6.70001C4.02457 6.69977 3.4547 6.81465 2.92414 7.03791C2.39357 7.26116 1.91301 7.58828 1.51074 8.00001C2.16963 8.67405 3.03092 9.11405 3.96322 9.25288C4.89552 9.39172 5.84765 9.22177 6.67434 8.76896C7.238 9.23788 7.62745 9.88285 7.77999 10.6H5.25019C5.15584 10.6001 5.06263 10.6206 4.97703 10.6603C4.89143 10.7 4.8155 10.7579 4.75452 10.8299C4.69353 10.9019 4.64895 10.9863 4.62387 11.0772C4.59879 11.1682 4.59382 11.2635 4.60929 11.3566L5.25929 15.2566C5.28453 15.4084 5.36278 15.5463 5.48013 15.6458C5.59749 15.7453 5.74633 15.7999 5.90019 15.8H11.1002C11.2541 15.7999 11.4029 15.7453 11.5203 15.6458C11.6376 15.5463 11.7159 15.4084 11.7411 15.2566L12.3911 11.3566C12.4066 11.2635 12.4016 11.1682 12.3765 11.0772C12.3514 10.9863 12.3069 10.9019 12.2459 10.8299C12.1849 10.7579 12.109 10.7 12.0234 10.6603C11.9378 10.6206 11.8445 10.6001 11.7502 10.6H9.22039C9.37293 9.88285 9.76239 9.23788 10.326 8.76896Z" />
                <path d="M8.5002 0.200012C7.85741 0.200012 7.22905 0.390621 6.69459 0.747736C6.16013 1.10485 5.74357 1.61243 5.49759 2.20629C5.2516 2.80015 5.18724 3.45362 5.31264 4.08406C5.43805 4.71449 5.74758 5.29359 6.2021 5.74811C6.65662 6.20263 7.23572 6.51216 7.86615 6.63756C8.49659 6.76297 9.15006 6.69861 9.74392 6.45262C10.3378 6.20664 10.8454 5.79008 11.2025 5.25562C11.5596 4.72116 11.7502 4.0928 11.7502 3.45001C11.7492 2.58838 11.4064 1.76232 10.7972 1.15306C10.1879 0.543785 9.36183 0.201044 8.5002 0.200012ZM9.1502 4.10001C9.1502 4.459 8.85918 4.75001 8.5002 4.75001C8.14121 4.75001 7.8502 4.459 7.8502 4.10001V2.80001C7.8502 2.44103 8.14121 2.15001 8.5002 2.15001C8.85918 2.15001 9.1502 2.44103 9.1502 2.80001V4.10001Z" />
            </svg>
        ),
        subtitle: 'Save Money',
        action: 'save money by spending less on alcohol (and related expenses)',
        effect: 'money saved',
        legacyTitle: 'Save money by spending less on alcohol',
        padding: '50px'
    },
    {
        key: 'emotions',
        icon: (
            <svg
                style={{
                    width: '100%',
                    height: '100%'
                }}
                width="17"
                height="16"
                viewBox="0 0 17 16"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path d="M16.2254 6.97683C16.4062 6.4602 16.5 5.88319 16.5 5.21225C16.5 2.99814 14.7118 1.20001 12.5017 1.20001C10.6498 1.20001 9.38367 2.08313 8.9462 3.76177C8.91682 3.87447 8.81683 3.95624 8.70036 3.95624C8.58356 3.95624 8.48362 3.87397 8.4528 3.76132C7.99355 2.08297 6.35005 1.20001 4.49833 1.20001C2.2882 1.20001 0.5 2.99814 0.5 5.21225C0.5 7.43307 1.5247 8.63405 3.10527 10.0296C3.86877 10.7073 4.63227 11.3782 5.39577 12.0559C6.07396 12.652 6.74929 13.251 7.42362 13.8491L7.50665 13.9227C8.07215 14.4243 8.92249 14.4258 9.48857 13.9249C10.193 13.3016 10.8952 12.6772 11.5975 12.0559C12.361 11.3782 13.1245 10.7073 13.888 10.0296C14.7587 9.25803 15.4619 8.55354 15.924 7.69473C16.0004 7.53079 16.1675 7.15769 16.2254 6.97683Z" />
            </svg>
        ),
        subtitle: 'Find Healthier Coping Strategies',
        action: 'find healthier strategies for coping with tough emotions',
        effect: 'better emotional coping',
        legacyTitle: 'Find healthier coping strategies',
        padding: '6px'
    },
    {
        key: 'stress',
        icon: (
            <svg
                style={{
                    width: '100%',
                    height: '100%'
                }}
                width="17"
                height="16"
                viewBox="0 0 17 16"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g clipPath="url(#clip0_4087_30)">
                    <path d="M8.68013 0.588975C9.13082 0.093207 9.95121 0.479265 9.85645 1.14256L9.19113 5.79982H15.5185C16.1088 5.79982 16.4187 6.50043 16.0216 6.93724L8.31852 15.4107C7.86782 15.9064 7.04744 15.5204 7.14219 14.8571L7.80752 10.1998H1.48017C0.889833 10.1998 0.579902 9.49922 0.977008 9.06241L8.68013 0.588975Z" />
                </g>
                <defs>
                    <clipPath id="clip0_4087_30">
                        <rect
                            width="16"
                            height="16"
                            fill="white"
                            transform="translate(0.5)"
                        />
                    </clipPath>
                </defs>
            </svg>
        ),
        subtitle: 'Reduce Stress and Anxiety',
        action: 'reduce stress and anxiety',
        effect: 'reduced stress and anxiety',
        legacyTitle: 'Reduce stress and anxiety',
        padding: '20px'
    },
    {
        key: 'relationships',
        icon: (
            <svg
                style={{
                    width: '100%',
                    height: '100%'
                }}
                width="17"
                height="16"
                viewBox="0 0 17 16"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g clipPath="url(#clip0_4087_20)">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M5.64286 3.71429C5.64286 2.13633 6.92204 0.857147 8.5 0.857147C10.078 0.857147 11.3571 2.13633 11.3571 3.71429C11.3571 5.29225 10.078 6.57143 8.5 6.57143C6.92204 6.57143 5.64286 5.29225 5.64286 3.71429Z"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M11.3571 6C11.3571 4.73764 12.3805 3.71429 13.6429 3.71429C14.9052 3.71429 15.9286 4.73764 15.9286 6C15.9286 7.26237 14.9052 8.28572 13.6429 8.28572C12.3805 8.28572 11.3571 7.26237 11.3571 6Z"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M1.07143 6C1.07143 4.73764 2.09478 3.71429 3.35714 3.71429C4.61951 3.71429 5.64286 4.73764 5.64286 6C5.64286 7.26237 4.61951 8.28572 3.35714 8.28572C2.09478 8.28572 1.07143 7.26237 1.07143 6Z"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M4.16466 10.0895C5.0774 8.66241 6.67779 7.71429 8.5 7.71429C10.3224 7.71429 11.923 8.66265 12.8357 10.0901C13.4667 11.0769 13.7396 12.2668 13.6116 13.427C13.5916 13.6083 13.4862 13.7692 13.328 13.8599C11.9053 14.6763 10.2563 15.1429 8.5 15.1429C6.74375 15.1429 5.09473 14.6763 3.672 13.8599C3.51378 13.7692 3.40842 13.6083 3.38841 13.427C3.26033 12.2666 3.53346 11.0765 4.16466 10.0895Z"
                    />
                    <path d="M3.22936 9.43138C3.22018 9.44548 3.21106 9.45961 3.202 9.47378C2.46641 10.6239 2.12977 11.9937 2.23312 13.344C1.76984 13.2736 1.32034 13.1605 0.888898 13.0085L0.80131 12.9777C0.64153 12.9214 0.529888 12.7763 0.51645 12.6074L0.509084 12.5149C0.503061 12.4392 0.5 12.3627 0.5 12.2857C0.5 10.7506 1.7107 9.49822 3.22936 9.43138Z" />
                    <path d="M14.7672 13.344C14.8705 11.9939 14.534 10.6244 13.7987 9.47443C13.7895 9.46004 13.7802 9.4457 13.7709 9.4314C15.2894 9.49838 16.5 10.7507 16.5 12.2857C16.5 12.3627 16.4969 12.4392 16.4909 12.5149L16.4835 12.6074C16.4701 12.7763 16.3585 12.9214 16.1987 12.9777L16.1111 13.0085C15.6797 13.1604 15.2303 13.2736 14.7672 13.344Z" />
                </g>
                <defs>
                    <clipPath id="clip0_4087_20">
                        <rect
                            width="16"
                            height="16"
                            fill="white"
                            transform="translate(0.5)"
                        />
                    </clipPath>
                </defs>
            </svg>
        ),
        subtitle: 'Improve Relationships',
        action: 'improve the relationships that matter most to you',
        effect: 'healthier relationships',
        legacyTitle: 'Improve relationships',
        padding: '20px'
    }
];

export const MED_FIRST_GOAL_CHOICES: Choice[] = [
    {
        key: 'health',
        icon: (
            <svg
                style={{
                    width: '100%',
                    height: '100%'
                }}
                width="17"
                height="16"
                viewBox="0 0 17 16"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g clipPath="url(#clip0_4087_13)">
                    <g clipPath="url(#clip1_4087_13)">
                        <path d="M9.84954 11.531C9.80153 11.595 9.73889 11.6465 9.66686 11.6812C9.59483 11.7159 9.51552 11.7329 9.43559 11.7306C9.35566 11.7284 9.27743 11.707 9.20747 11.6682C9.13752 11.6295 9.07787 11.5746 9.03354 11.508L6.56454 7.804L5.99454 8.757C5.95017 8.83105 5.88738 8.89235 5.81229 8.93493C5.7372 8.97752 5.65236 8.99993 5.56604 9H2.47754C4.66254 12.317 8.49954 15.482 8.49954 15.482C8.49954 15.482 12.3365 12.317 14.5215 9H11.7495L9.84954 11.531Z" />
                        <path d="M15.59 7C15.841 6.41698 15.9801 5.79194 16 5.1575C16.0118 4.27358 15.7365 3.40969 15.2155 2.69556C14.6945 1.98143 13.9559 1.4556 13.1105 1.19704C12.2652 0.938482 11.3588 0.961148 10.5275 1.26164C9.6961 1.56212 8.98467 2.12422 8.5 2.8635C8.12576 2.3029 7.62059 1.84189 7.0282 1.52034C6.4358 1.19879 5.77399 1.02637 5.1 1.018C4.00772 1.02435 2.96258 1.46377 2.19392 2.23983C1.42526 3.0159 0.995876 4.06521 1 5.1575C1.02008 5.79197 1.15934 6.41701 1.4105 7H0.5V8H5.283L6.5225 5.9345L9.476 10.365L11.25 8H16.5V7H15.59Z" />
                    </g>
                </g>
                <defs>
                    <clipPath id="clip0_4087_13">
                        <rect
                            width="16"
                            height="16"
                            fill="white"
                            transform="translate(0.5)"
                        />
                    </clipPath>
                    <clipPath id="clip1_4087_13">
                        <rect
                            width="16"
                            height="16"
                            fill="white"
                            transform="translate(0.5)"
                        />
                    </clipPath>
                </defs>
            </svg>
        ),
        subtitle: 'Improve Health and Wellness',
        legacyTitle: 'Improve overall health and wellness',
        padding: '20px'
    },
    {
        key: 'weight',
        icon: (
            <svg
                style={{
                    width: '100%',
                    height: '100%'
                }}
                width="17"
                height="16"
                viewBox="0 0 17 16"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path d="M10.0951 6.42086C10.0951 6.42086 10.7853 2.36098 7.96892 0.598434C7.92696 1.296 7.73831 1.97687 7.41531 2.59657C7.09231 3.21627 6.64221 3.76086 6.09441 4.19478C4.89162 5.2523 2.62945 7.63013 2.65351 10.1652C2.64487 11.2489 2.93924 12.3135 3.50342 13.2388C4.0676 14.1641 4.87913 14.9134 5.84645 15.402C5.88101 14.9127 6.01289 14.4352 6.23436 13.9975C6.45583 13.5598 6.76244 13.1707 7.13621 12.853C7.45294 12.6094 7.718 12.3052 7.91593 11.9581C8.11386 11.611 8.24069 11.228 8.28904 10.8314C9.11705 11.2716 9.81665 11.9191 10.3194 12.7107C10.8221 13.5023 11.1108 14.4108 11.1572 15.3474V15.3594C12.0702 14.9412 12.8498 14.2786 13.4095 13.4448C13.9693 12.611 14.2875 11.6386 14.3289 10.6352C14.5287 8.25373 13.2242 5.01545 12.0667 3.95699C11.6297 4.93259 10.9511 5.78061 10.0951 6.42086Z" />
            </svg>
        ),
        subtitle: 'Lose Weight',
        legacyTitle: 'Lose weight by cutting alcohol calories (and drunchies)',
        padding: '10px'
    },
    {
        key: 'heart_disease',
        icon: (
            <svg
                style={{
                    width: '100%',
                    height: '100%'
                }}
                width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                <path d="M15.7254 6.97676C15.9062 6.46014 16 5.88313 16 5.21219C16 2.99808 14.2118 1.19995 12.0017 1.19995C10.1498 1.19995 8.88367 2.08307 8.4462 3.76171C8.41682 3.87441 8.31683 3.95618 8.20036 3.95618C8.08356 3.95618 7.98362 3.87391 7.9528 3.76126C7.49355 2.08291 5.85005 1.19995 3.99833 1.19995C1.7882 1.19995 0 2.99808 0 5.21219C0 7.433 1.0247 8.63399 2.60527 10.0296C3.36877 10.7072 4.13227 11.3781 4.89577 12.0558C5.57396 12.6519 6.24929 13.2509 6.92362 13.849L7.00665 13.9227C7.57215 14.4242 8.42249 14.4257 8.98857 13.9248C9.69297 13.3015 10.3952 12.6771 11.0975 12.0558C11.861 11.3781 12.6245 10.7072 13.388 10.0296C14.2587 9.25797 14.9619 8.55348 15.424 7.69467C15.5004 7.53073 15.6675 7.15763 15.7254 6.97676Z" />
            </svg>
        ),
        subtitle: 'Decrease Heart Disease Risk',
        legacyTitle: 'Decrease Heart Disease Risk',
        padding: '20px'
    },
    {
        key: 'liver_disease',
        icon: (
            <svg
                style={{
                    width: '100%',
                    height: '100%'
                }}
                width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M8.73597 3.80026C8.90052 3.80458 9.05606 3.87632 9.16617 3.99867L15.6462 11.1987C15.8678 11.445 15.8479 11.8244 15.6016 12.046C15.3553 12.2677 14.9759 12.2477 14.7542 12.0014L8.69728 5.27149L4.82446 9.14431C4.59014 9.37863 4.21025 9.37863 3.97593 9.14431L0.375931 5.54431C0.141617 5.31 0.141617 4.9301 0.375931 4.69579C0.610246 4.46147 0.990145 4.46147 1.22446 4.69579L4.4002 7.87152L8.29593 3.97579C8.41232 3.85939 8.57142 3.79593 8.73597 3.80026Z" />
                <path fillRule="evenodd" clipRule="evenodd" d="M15.2002 5.96006C15.5316 5.96006 15.8002 6.22869 15.8002 6.56006V11.6001C15.8002 11.9314 15.5316 12.2001 15.2002 12.2001H10.1602C9.82883 12.2001 9.56021 11.9314 9.56021 11.6001C9.56021 11.2687 9.82883 11.0001 10.1602 11.0001H14.6002V6.56006C14.6002 6.22869 14.8688 5.96006 15.2002 5.96006Z" />
            </svg>
        ),
        subtitle: 'Decrease Liver & Kidney Disease Risk',
        legacyTitle: 'Decrease Liver & Kidney Disease Risk',
        padding: '5px'
    },
    {
        key: 'fitness',
        icon: (
            <svg
                style={{
                    width: '100%',
                    height: '100%'
                }}
                width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_5543_2832)">
                    <g clipPath="url(#clip1_5543_2832)">
                        <path d="M13.3899 7.972C11.0729 6.75 7.65291 7.888 6.08991 9.133C6.03591 9.053 5.97691 8.969 5.91491 8.879C5.4788 8.33031 5.14052 7.71058 4.91491 7.047C4.81688 6.42082 4.76175 5.78869 4.74991 5.155C4.90408 5.15441 5.05794 5.14103 5.20991 5.115C5.88384 4.91322 6.48501 4.52077 6.94091 3.985C7.08534 3.76978 7.1638 3.51706 7.16664 3.25788C7.16948 2.9987 7.09659 2.74433 6.95691 2.526C7.07791 2.18272 7.1332 1.81973 7.11991 1.456C7.12037 1.27785 7.08248 1.10168 7.0088 0.939485C6.93512 0.777284 6.82738 0.632849 6.69291 0.515997C6.66592 0.494082 6.63677 0.474982 6.60591 0.458997C5.87644 0.0866032 5.05672 -0.0724875 4.24091 -3.12005e-06C2.25191 -3.12005e-06 1.08091 4.421 0.558907 7.059C-0.141093 10.627 1.03491 14.036 1.69191 14.706C2.76291 15.796 5.13391 15.63 5.69191 15.575C6.62676 15.8708 7.60137 16.0219 8.58191 16.023C8.85191 16.023 9.12091 16.012 9.38891 15.988C11.0654 15.9847 12.7104 15.5324 14.1529 14.678C14.6362 14.3248 15.026 13.859 15.2886 13.3211C15.5512 12.7832 15.6786 12.1893 15.6599 11.591C15.6145 10.846 15.3829 10.1244 14.9863 9.4921C14.5897 8.85984 14.0408 8.33718 13.3899 7.972ZM12.8129 12.05C11.7293 12.6938 10.4923 13.034 9.23191 13.035C8.63888 13.0345 8.04826 12.9596 7.47391 12.812C7.28517 12.7592 7.12458 12.6347 7.0265 12.465C6.92843 12.2953 6.90067 12.094 6.94915 11.9041C6.99763 11.7143 7.11851 11.5509 7.28593 11.449C7.45334 11.3471 7.65397 11.3148 7.84491 11.359C8.55086 11.5418 9.28603 11.5828 10.0079 11.4799C10.7299 11.3769 11.4242 11.1319 12.0509 10.759C12.1358 10.7049 12.2307 10.6684 12.33 10.6517C12.4292 10.635 12.5309 10.6385 12.6288 10.662C12.7267 10.6854 12.8189 10.7283 12.8998 10.7881C12.9808 10.8479 13.0489 10.9234 13.1001 11.0101C13.1512 11.0968 13.1844 11.1929 13.1977 11.2927C13.2109 11.3925 13.2039 11.494 13.1771 11.591C13.1503 11.688 13.1043 11.7787 13.0417 11.8575C12.9791 11.9364 12.9013 12.0018 12.8129 12.05Z" />
                    </g>
                </g>
                <defs>
                    <clipPath id="clip0_5543_2832">
                        <rect width="16" height="16" />
                    </clipPath>
                    <clipPath id="clip1_5543_2832">
                        <rect width="16" height="16" />
                    </clipPath>
                </defs>
            </svg>
        ),
        subtitle: 'Improve Fitness and Mobility',
        legacyTitle: 'Improve Fitness and Mobility',
        padding: '20px'
    },
    {
        key: 'hangover',
        icon: (
            <svg
                style={{
                    width: '100%',
                    height: '100%'
                }}
                width="17"
                height="16"
                viewBox="0 0 17 16"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g clipPath="url(#clip0_4087_5391)">
                    <g clipPath="url(#clip1_4087_5391)">
                        <path d="M8.5 0C8.83987 0 9.11538 0.275517 9.11538 0.615385V2.46154C9.11538 2.80141 8.83987 3.07692 8.5 3.07692C8.16013 3.07692 7.88462 2.80141 7.88462 2.46154V0.615385C7.88462 0.275517 8.16013 0 8.5 0Z" />
                        <path d="M4.80769 8C4.80769 5.96079 6.46079 4.30769 8.5 4.30769C10.5392 4.30769 12.1923 5.96079 12.1923 8C12.1923 10.0392 10.5392 11.6923 8.5 11.6923C6.46079 11.6923 4.80769 10.0392 4.80769 8Z" />
                        <path d="M14.1569 3.21341C14.3972 2.97308 14.3972 2.58344 14.1569 2.34312C13.9166 2.1028 13.5269 2.1028 13.2866 2.34312L11.9812 3.64855C11.7409 3.88887 11.7409 4.27851 11.9812 4.51883C12.2215 4.75916 12.6111 4.75916 12.8515 4.51883L14.1569 3.21341Z" />
                        <path d="M16.5 8C16.5 8.33987 16.2245 8.61538 15.8846 8.61538H14.0385C13.6986 8.61538 13.4231 8.33987 13.4231 8C13.4231 7.66013 13.6986 7.38462 14.0385 7.38462H15.8846C16.2245 7.38462 16.5 7.66013 16.5 8Z" />
                        <path d="M13.2865 13.6568C13.5268 13.8971 13.9165 13.8971 14.1568 13.6568C14.3971 13.4165 14.3971 13.0269 14.1568 12.7865L12.8514 11.4811C12.6111 11.2408 12.2214 11.2408 11.9811 11.4811C11.7408 11.7214 11.7408 12.1111 11.9811 12.3514L13.2865 13.6568Z" />
                        <path d="M8.5 12.9231C8.83987 12.9231 9.11538 13.1986 9.11538 13.5385V15.3846C9.11538 15.7245 8.83987 16 8.5 16C8.16013 16 7.88462 15.7245 7.88462 15.3846V13.5385C7.88462 13.1986 8.16013 12.9231 8.5 12.9231Z" />
                        <path d="M5.01898 12.3514C5.2593 12.1111 5.2593 11.7214 5.01898 11.4811C4.77865 11.2408 4.38901 11.2408 4.14869 11.4811L2.84326 12.7865C2.60294 13.0269 2.60294 13.4165 2.84326 13.6568C3.08359 13.8972 3.47323 13.8972 3.71355 13.6568L5.01898 12.3514Z" />
                        <path d="M3.57692 8C3.57692 8.33987 3.30141 8.61538 2.96154 8.61538H1.11538C0.775517 8.61538 0.5 8.33987 0.5 8C0.5 7.66013 0.775517 7.38462 1.11538 7.38462H2.96154C3.30141 7.38462 3.57692 7.66013 3.57692 8Z" />
                        <path d="M4.1486 4.51883C4.38892 4.75915 4.77856 4.75915 5.01888 4.51883C5.25921 4.2785 5.25921 3.88886 5.01888 3.64854L3.71346 2.34311C3.47313 2.10279 3.08349 2.10279 2.84317 2.34311C2.60285 2.58344 2.60285 2.97308 2.84317 3.2134L4.1486 4.51883Z" />
                    </g>
                </g>
                <defs>
                    <clipPath id="clip0_4087_5391">
                        <rect
                            width="16"
                            height="16"
                            fill="white"
                            transform="translate(0.5)"
                        />
                    </clipPath>
                    <clipPath id="clip1_4087_5391">
                        <rect
                            width="16"
                            height="16"
                            fill="white"
                            transform="translate(0.5)"
                        />
                    </clipPath>
                </defs>
            </svg>
        ),
        subtitle: 'Avoid Hangovers',
        legacyTitle: 'Avoid hangovers and other negative next-day effects',
        padding: '20px'
    },
    {
        key: 'blackout',
        icon: (
            <svg
                style={{
                    width: '100%',
                    height: '100%'
                }}
                width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M2.76406 0.199951C2.43269 0.199951 2.16406 0.46858 2.16406 0.799951V4.72722C2.16406 7.73608 4.46842 10.2302 7.40039 10.5328V14.6H4.72773C4.39636 14.6 4.12773 14.8686 4.12773 15.2C4.12773 15.5313 4.39636 15.8 4.72773 15.8H11.2732C11.6046 15.8 11.8732 15.5313 11.8732 15.2C11.8732 14.8686 11.6046 14.6 11.2732 14.6H8.60039V10.5328C11.5324 10.2302 13.8368 7.73611 13.8368 4.72722V0.799951C13.8368 0.46858 13.5682 0.199951 13.2368 0.199951H2.76406ZM3.36406 4.12722V1.39995H12.6368V4.12722H3.36406Z" />
            </svg>
        ),
        subtitle: 'Stop Blacking or graying Out',
        legacyTitle: 'Stop blacking (or graying) out',
        padding: '20px'
    },
    {
        key: 'relationships',
        icon: (
            <svg
                style={{
                    width: '100%',
                    height: '100%'
                }}
                width="17"
                height="16"
                viewBox="0 0 17 16"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g clipPath="url(#clip0_4087_20)">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M5.64286 3.71429C5.64286 2.13633 6.92204 0.857147 8.5 0.857147C10.078 0.857147 11.3571 2.13633 11.3571 3.71429C11.3571 5.29225 10.078 6.57143 8.5 6.57143C6.92204 6.57143 5.64286 5.29225 5.64286 3.71429Z"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M11.3571 6C11.3571 4.73764 12.3805 3.71429 13.6429 3.71429C14.9052 3.71429 15.9286 4.73764 15.9286 6C15.9286 7.26237 14.9052 8.28572 13.6429 8.28572C12.3805 8.28572 11.3571 7.26237 11.3571 6Z"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M1.07143 6C1.07143 4.73764 2.09478 3.71429 3.35714 3.71429C4.61951 3.71429 5.64286 4.73764 5.64286 6C5.64286 7.26237 4.61951 8.28572 3.35714 8.28572C2.09478 8.28572 1.07143 7.26237 1.07143 6Z"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M4.16466 10.0895C5.0774 8.66241 6.67779 7.71429 8.5 7.71429C10.3224 7.71429 11.923 8.66265 12.8357 10.0901C13.4667 11.0769 13.7396 12.2668 13.6116 13.427C13.5916 13.6083 13.4862 13.7692 13.328 13.8599C11.9053 14.6763 10.2563 15.1429 8.5 15.1429C6.74375 15.1429 5.09473 14.6763 3.672 13.8599C3.51378 13.7692 3.40842 13.6083 3.38841 13.427C3.26033 12.2666 3.53346 11.0765 4.16466 10.0895Z"
                    />
                    <path d="M3.22936 9.43138C3.22018 9.44548 3.21106 9.45961 3.202 9.47378C2.46641 10.6239 2.12977 11.9937 2.23312 13.344C1.76984 13.2736 1.32034 13.1605 0.888898 13.0085L0.80131 12.9777C0.64153 12.9214 0.529888 12.7763 0.51645 12.6074L0.509084 12.5149C0.503061 12.4392 0.5 12.3627 0.5 12.2857C0.5 10.7506 1.7107 9.49822 3.22936 9.43138Z" />
                    <path d="M14.7672 13.344C14.8705 11.9939 14.534 10.6244 13.7987 9.47443C13.7895 9.46004 13.7802 9.4457 13.7709 9.4314C15.2894 9.49838 16.5 10.7507 16.5 12.2857C16.5 12.3627 16.4969 12.4392 16.4909 12.5149L16.4835 12.6074C16.4701 12.7763 16.3585 12.9214 16.1987 12.9777L16.1111 13.0085C15.6797 13.1604 15.2303 13.2736 14.7672 13.344Z" />
                </g>
                <defs>
                    <clipPath id="clip0_4087_20">
                        <rect
                            width="16"
                            height="16"
                            fill="white"
                            transform="translate(0.5)"
                        />
                    </clipPath>
                </defs>
            </svg>
        ),
        subtitle: 'Improve Relationships',
        legacyTitle: 'Improve relationships',
        padding: '20px'
    },
    {
        key: 'stress',
        icon: (
            <svg
                style={{
                    width: '100%',
                    height: '100%'
                }}
                width="17"
                height="16"
                viewBox="0 0 17 16"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g clipPath="url(#clip0_4087_30)">
                    <path d="M8.68013 0.588975C9.13082 0.093207 9.95121 0.479265 9.85645 1.14256L9.19113 5.79982H15.5185C16.1088 5.79982 16.4187 6.50043 16.0216 6.93724L8.31852 15.4107C7.86782 15.9064 7.04744 15.5204 7.14219 14.8571L7.80752 10.1998H1.48017C0.889833 10.1998 0.579902 9.49922 0.977008 9.06241L8.68013 0.588975Z" />
                </g>
                <defs>
                    <clipPath id="clip0_4087_30">
                        <rect
                            width="16"
                            height="16"
                            fill="white"
                            transform="translate(0.5)"
                        />
                    </clipPath>
                </defs>
            </svg>
        ),
        subtitle: 'Reduce Stress and Anxiety',
        legacyTitle: 'Reduce stress and anxiety',
        padding: '20px'
    },
    {
        key: 'sleep',
        icon: (
            <svg
                style={{
                    width: '100%',
                    height: '100%'
                }}
                width="17"
                height="16"
                viewBox="0 0 17 16"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g clipPath="url(#clip0_4087_84)">
                    <g clipPath="url(#clip1_4087_84)">
                        <path d="M6.5 0C3 0.9 0.5 4.1 0.5 7.9C0.5 12.4 4.1 16 8.6 16C12.4 16 15.5 13.5 16.5 10C10.4 11.7 4.8 6.1 6.5 0Z" />
                    </g>
                </g>
                <defs>
                    <clipPath id="clip0_4087_84">
                        <rect
                            width="16"
                            height="16"
                            fill="white"
                            transform="translate(0.5)"
                        />
                    </clipPath>
                    <clipPath id="clip1_4087_84">
                        <rect
                            width="16"
                            height="16"
                            fill="white"
                            transform="translate(0.5)"
                        />
                    </clipPath>
                </defs>
            </svg>
        ),
        subtitle: 'Improve Sleep Quality',
        legacyTitle: 'Sleep better and increase energy',
        padding: '20px'
    },
    {
        key: 'mental_sharpness',
        icon: (
            <svg
                style={{
                    width: '100%',
                    height: '100%'
                }}
                width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_5543_2723)">
                    <g clipPath="url(#clip1_5543_2723)">
                        <path d="M16 7.55179C16 6.89079 15.5723 6.30756 14.9502 6.09371L14.7558 6.03538L14.7363 5.82153C14.6586 4.79115 13.7837 3.95519 12.7339 3.95519H12.52L12.4423 3.74134C12.2284 3.19699 11.723 2.82761 11.1397 2.82761C10.9453 2.82761 10.7509 2.88593 10.5565 2.96369L10.4593 3.00258C10.051 3.23587 9.75942 3.68301 9.75942 4.20792C9.75942 4.38289 9.62333 4.51898 9.44836 4.51898C9.27339 4.51898 9.1373 4.38289 9.1373 4.20792C9.1373 3.56637 9.44836 3.00258 9.91494 2.6332C9.70109 2.47767 9.42892 2.3999 9.15674 2.3999C8.82624 2.3999 8.51519 2.51655 8.26245 2.7304L8.10693 2.86649L7.91251 2.76928C7.60146 2.61375 7.23208 2.51655 6.88214 2.51655C6.2017 2.51655 5.56015 2.82761 5.15188 3.37196L5.0158 3.56637L4.80194 3.4886C4.62697 3.43028 4.47145 3.3914 4.29648 3.3914C3.77157 3.3914 3.28554 3.68301 3.05225 4.16904L2.95504 4.36345L2.70231 4.34401H2.66343C1.73025 4.34401 0.972053 5.10221 0.972053 6.03538C0.972053 6.96855 1.73026 7.70731 2.64399 7.72675C2.78007 7.68787 2.91616 7.7462 2.99392 7.86284C3.07169 7.99893 3.03281 8.19334 2.87728 8.29055C2.72175 8.38775 2.6051 8.54328 2.56622 8.71825C2.52734 8.89322 2.54678 9.08763 2.64399 9.24316C2.72175 9.37925 2.68287 9.57366 2.52734 9.67086C2.48846 9.6903 2.43013 9.70974 2.37181 9.70974C2.25516 9.70974 2.15796 9.65142 2.09964 9.55422C1.90522 9.24316 1.86634 8.89322 1.94411 8.54328C1.96355 8.44607 2.00243 8.34887 2.06075 8.25166C1.30255 8.05725 0.680437 7.47402 0.447145 6.73526C0.155529 7.14352 0 7.64899 0 8.15446C0 9.55422 1.14702 10.6818 2.52734 10.6818C2.70231 10.6818 2.87728 10.6624 3.03281 10.6235L3.11057 10.604L3.18834 10.6429C3.34386 10.7012 3.51883 10.7401 3.6938 10.7596C3.6938 10.0014 4.10207 9.2626 4.84083 8.91266C4.99635 8.8349 5.19077 8.91266 5.26853 9.06819C5.34629 9.22372 5.26853 9.41813 5.113 9.49589C4.41312 9.82639 4.12151 10.6624 4.452 11.3428C4.47145 11.3622 4.47145 11.3817 4.47145 11.4011C4.89915 12.2565 5.63791 12.6842 6.68773 12.6842C7.26318 12.6842 8.20607 12.9253 9.07703 13.3141L9.0712 13.3102L11.2953 14.0645C12.6561 14.4145 14.017 13.598 14.3669 12.2371C14.4253 11.9455 14.4642 11.6539 14.4253 11.3622C14.3281 10.3124 13.5699 9.43757 12.5395 9.18484C12.3645 9.14595 12.2673 8.97098 12.3062 8.79601C12.3451 8.62104 12.52 8.52384 12.695 8.56272C13.842 8.85434 14.7363 9.78751 14.9891 10.9345C15.5917 10.6624 15.9806 10.0597 15.9806 9.39869C15.9806 9.10707 15.9222 8.85434 15.7861 8.6016L15.7278 8.44607L15.8056 8.29055C15.9417 8.07669 16 7.80452 16 7.55179ZM7.05905 4.48982C8.16719 4.48982 9.08092 5.38411 9.08092 6.51169C9.08092 6.64778 8.96428 6.76442 8.82819 6.76442C8.6921 6.76442 8.57546 6.64778 8.57546 6.51169C8.57546 5.67572 7.89502 4.99529 7.05905 4.99529C6.92296 4.99529 6.80632 4.87864 6.80632 4.74255C6.80632 4.60646 6.92296 4.48982 7.05905 4.48982ZM4.95942 5.6174C4.51227 6.25895 3.77351 6.60889 3.03475 6.60889C2.64593 6.60889 2.23767 6.51169 1.86829 6.29784C1.75164 6.22007 1.71276 6.06454 1.77108 5.9479C1.84885 5.83125 2.00437 5.79237 2.12102 5.85069C2.99587 6.35616 4.12345 6.06454 4.64836 5.17025C4.55115 4.9564 4.49283 4.72311 4.49283 4.48982C4.49283 4.35373 4.60948 4.23708 4.74556 4.23708C4.88165 4.23708 4.9983 4.35373 4.9983 4.48982C4.97886 5.03417 5.426 5.50075 5.97035 5.52019C6.10644 5.52019 6.22309 5.63684 6.22309 5.77293C6.22309 5.9479 6.10644 6.0451 5.97035 6.0451C5.58153 6.0451 5.23159 5.87013 4.95942 5.6174ZM6.20364 10.5165C6.16476 10.5943 6.06756 10.6332 5.98979 10.6332C5.95091 10.6332 5.89259 10.6138 5.85371 10.5943C5.73706 10.5165 5.69818 10.361 5.77594 10.2444C6.20364 9.56394 5.98979 8.66965 5.30936 8.24194C5.19271 8.16418 5.15383 8.00865 5.23159 7.892C5.30936 7.77536 5.46488 7.73648 5.58153 7.81424C6.49526 8.39747 6.76744 9.60282 6.20364 10.5165ZM7.91446 8.80573C7.07849 8.41691 6.49526 7.61983 6.37861 6.7061C6.35917 6.57001 6.45638 6.43392 6.59247 6.41448C6.72855 6.39504 6.86464 6.49225 6.88408 6.62833C7.00073 7.4643 7.56452 8.16418 8.3616 8.43635C8.92539 8.63076 9.52807 8.59188 10.0724 8.33915C10.6168 8.08641 11.0056 7.61983 11.2 7.05604C11.2389 6.91995 11.3944 6.86163 11.5305 6.90051C11.6666 6.93939 11.7249 7.09492 11.686 7.23101C11.4527 7.93089 10.9473 8.47524 10.2863 8.78629C9.91689 8.96126 9.50863 9.05847 9.10036 9.05847C9.0226 9.05847 8.94484 9.05847 8.84763 9.03903C9.06148 9.38897 9.19757 9.79723 9.19757 10.2444C9.19757 10.3805 9.08092 10.4971 8.94484 10.4971C8.80875 10.4971 8.6921 10.3999 8.6921 10.2638C8.6921 9.68058 8.40049 9.13623 7.91446 8.80573ZM11.9582 11.3331C11.4722 12.033 10.6945 12.4218 9.89745 12.4218C9.41142 12.4218 8.92539 12.2857 8.49769 11.9941C8.38104 11.9163 8.3616 11.7608 8.43937 11.6441C8.51713 11.5275 8.67266 11.508 8.78931 11.5858C9.23645 11.8774 9.76136 11.9941 10.2863 11.8969C10.8112 11.7997 11.2583 11.508 11.5694 11.0609C11.6277 10.9443 11.7832 10.9054 11.8999 10.9831C12.0165 11.0609 12.036 11.2164 11.9582 11.3331ZM13.2413 7.60039C13.1052 7.60039 12.9886 7.48374 12.9886 7.34765C12.9886 6.20063 12.0554 5.26746 10.9084 5.26746C10.7723 5.26746 10.6556 5.15081 10.6556 5.01473C10.6556 4.87864 10.7723 4.76199 10.9084 4.76199C12.3276 4.76199 13.494 5.92846 13.494 7.34765C13.494 7.48374 13.3774 7.60039 13.2413 7.60039Z" />
                    </g>
                </g>
                <defs>
                    <clipPath id="clip0_5543_2723">
                        <rect width="16" height="16" />
                    </clipPath>
                    <clipPath id="clip1_5543_2723">
                        <rect width="16" height="11.7463"  transform="translate(0 2.3999)"/>
                    </clipPath>
                </defs>
            </svg>
        ),
        subtitle: 'Improve Mental Sharpness',
        legacyTitle: 'Improve Mental Sharpness',
        padding: '20px'
    },
    {
        key: 'emotions',
        icon: (
            <svg
                style={{
                    width: '100%',
                    height: '100%'
                }}
                width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.17565 5.39328C7.81318 5.39328 8.32217 5.6502 8.65273 5.88112C8.82046 5.99828 8.95176 6.11521 9.04246 6.20423C9.07569 6.23291 9.1535 6.30678 9.19896 6.37276C9.41809 6.64236 9.37344 7.03558 9.09924 7.25103C8.82623 7.46554 8.4286 7.42296 8.20886 7.1565C7.85377 6.73748 7.3721 6.63961 7.17565 6.64305C6.6814 6.64305 6.021 6.90519 5.2684 7.58807L4.21529 8.62787C3.63243 9.21626 2.99027 9.88928 2.66223 10.3088C2.04888 11.0931 1.8531 11.9455 2.37107 12.7623C2.66478 13.2255 3.05194 13.5281 3.40621 13.7154C3.56903 13.8015 4.20688 14.0124 4.76565 13.9311C4.97801 13.8911 5.25036 13.7945 5.57786 13.5363C5.95214 13.2412 6.32369 12.8751 6.60742 12.5748L7.06527 12.0644C7.28743 11.7973 7.68784 11.7577 7.95958 11.9761C8.23134 12.1945 8.27156 12.5882 8.04942 12.8554L7.53869 13.4254C7.23592 13.7458 6.81652 14.1616 6.37308 14.5113C5.88286 14.8978 5.41933 15.0805 5.0048 15.1585C4.01836 15.3141 3.12673 14.9951 2.80423 14.8161C2.28981 14.5442 1.72272 14.1021 1.29243 13.4235C0.393712 12.0062 0.851176 10.5743 1.65455 9.54699C2.03486 9.06067 2.72869 8.33736 3.30472 7.75587L4.38567 6.68877C4.8233 6.23445 5.99399 5.33929 7.17565 5.39328Z" />
                <path d="M8.82396 10.6068C8.18643 10.6068 7.67744 10.3499 7.34687 10.119C7.17915 10.0018 7.04785 9.88488 6.95715 9.79587C6.92392 9.76718 6.84611 9.69331 6.80065 9.62733C6.58152 9.35773 6.62617 8.96452 6.90037 8.74907C7.17338 8.53456 7.57101 8.57713 7.79075 8.84359C8.14584 9.26261 8.62751 9.36049 8.82396 9.35705C9.31821 9.35705 9.97861 9.09491 10.7312 8.41203L11.7843 7.37222C12.3672 6.78384 13.0093 6.11082 13.3374 5.69132C13.9507 4.90701 14.1465 4.05465 13.6285 3.23781C13.3348 2.77462 12.9477 2.472 12.5934 2.2847C12.4306 2.19862 11.7927 1.98771 11.234 2.069C11.0216 2.109 10.7492 2.20559 10.4217 2.46382C10.0475 2.75892 9.67592 3.12505 9.39219 3.42535L8.93434 3.93569C8.71218 4.20283 8.31177 4.24242 8.04003 4.02402C7.76827 3.8056 7.72804 3.41193 7.95019 3.14473L8.46092 2.57474C8.76369 2.25429 9.18309 1.83847 9.62653 1.48883C10.1167 1.1023 10.5803 0.91963 10.9948 0.841552C11.9813 0.685988 12.8729 1.00502 13.1954 1.18398C13.7098 1.45594 14.2769 1.89803 14.7072 2.5766C15.6059 3.99389 15.1484 5.42579 14.3451 6.45311C13.9647 6.93943 13.2709 7.66273 12.6949 8.24422L11.6139 9.31132C11.1763 9.76565 10.0056 10.6608 8.82396 10.6068Z" />
            </svg>
        ),
        subtitle: 'Find Healthier Coping Strategies',
        legacyTitle: 'Find healthier coping strategies',
        padding: '6px'
    }
];

export const END_GOALS: Choice[] = [
    {
        icon: null,
        key: 'Drink Less',
        title: 'Drink Less',
        subtitle: 'I\'d like to continue drinking, but with healthier habits.',
        jump: 1,
    },
    {
        icon: null,
        key: 'Complete Zero',
        title: 'Complete Zero',
        subtitle: 'I eventually want to cut alcohol out entirely.',
        jump: 2
    },
    {
        icon: null,
        key: 'Not Sure',
        title: 'I\'m Not Sure Yet',
        subtitle: 'I know I want to make a change, but I\'m not sure where it\'ll take me.',
        jump: 3
    }
];

export const END_GOALS2: Choice[] = [
    {
        icon: null,
        key: 'Drink Less',
        title: 'Drink Less',
        ctaIcon: {
            position: 'right',
            element: (
                <svg
                    width="12"
                    height="20"
                    viewBox="0 0 12 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M2 2L10 10L2 18"
                        stroke="white"
                        strokeWidth="2.66667"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            )
        }
    },
    {
        icon: null,
        key: 'Complete Zero',
        title: 'Complete Zero',
        ctaIcon: {
            position: 'right',
            element: (
                <svg
                    width="12"
                    height="20"
                    viewBox="0 0 12 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M2 2L10 10L2 18"
                        stroke="white"
                        strokeWidth="2.66667"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            )
        }
    },
    {
        icon: null,
        key: 'Not Sure',
        title: 'I\'m Not Sure Yet',
        ctaIcon: {
            position: 'right',
            element: (
                <svg
                    width="12"
                    height="20"
                    viewBox="0 0 12 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M2 2L10 10L2 18"
                        stroke="white"
                        strokeWidth="2.66667"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            )
        }
    }
];

export const CHALLENGE_END_GOALS: Choice[] = [
    {
        icon: null,
        key: 'Drink Less',
        subtitle: 'I\'d like to sustain a lower total than where I am today',
        jump: 1,
    },
    {
        icon: null,
        key: 'Complete Zero',
        subtitle: 'I\'d like to eventually get to complete zero',
        jump: 2
    },
    {
        icon: null,
        key: 'Challenge Reset',
        subtitle: 'I\'m just here for a 30-day reset',
        jump: 3
    },
    {
        icon: null,
        key: 'Not Sure',
        subtitle: 'I\'m not sure yet',
        jump: 4
    }
];

export const EFFECT_FREQUENCIES: Choice[] = [
    {
        icon: null,
        key: 'Less than once a month',
        subtitle: 'Less than once a month'
    },
    {
        icon: null,
        key: '1-2 times per month',
        subtitle: '1-2 times per month'
    },
    {
        icon: null,
        key: '1-2 times per week',
        subtitle: '1-2 times per week'
    },
    {
        icon: null,
        key: '2-4 times per week',
        subtitle: '3-4 times per week'
    },
    {
        icon: null,
        key: 'Daily or almost daily',
        subtitle: 'Daily or almost daily'
    }
];

export const CONCERN_LEVELS: Choice[] = [
    {
        icon: (
            <p
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '40px',
                    height: '40px',
                    border: '2px solid #B05DF1',
                    borderRadius: '50%',
                    fontFamily: 'Poppins',
                    fontSize: '20px',
                    lineHeight: '28px',
                    fontWeight: 700,
                    margin: '0',
                    transition: 'color 0.5s, background-color 0.5s',
                    color: '#B05DF1',
                    backgroundColor: 'white'
                }}
            >
                1
            </p>
        ),
        key: '1',
        subtitle: 'Never Concerned',
        orientation: 'horizontal'
    },
    {
        icon: (
            <p
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '40px',
                    height: '40px',
                    border: '2px solid #B05DF1',
                    borderRadius: '50%',
                    fontFamily: 'Poppins',
                    fontSize: '20px',
                    lineHeight: '28px',
                    fontWeight: 700,
                    margin: '0',
                    transition: 'color 0.5s, background-color 0.5s',
                    color: '#B05DF1',
                    backgroundColor: 'white'
                }}
            >
                2
            </p>
        ),
        key: '2',
        subtitle: 'Rarely Concerned',
        orientation: 'horizontal'
    },
    {
        icon: (
            <p
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '40px',
                    height: '40px',
                    border: '2px solid #B05DF1',
                    borderRadius: '50%',
                    fontFamily: 'Poppins',
                    fontSize: '20px',
                    lineHeight: '28px',
                    fontWeight: 700,
                    margin: '0',
                    transition: 'color 0.5s, background-color 0.5s',
                    color: '#B05DF1',
                    backgroundColor: 'white'
                }}
            >
                3
            </p>
        ),
        key: '3',
        subtitle: 'Occasionally Concerned',
        orientation: 'horizontal'
    },
    {
        icon: (
            <p
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '40px',
                    height: '40px',
                    border: '2px solid #B05DF1',
                    borderRadius: '50%',
                    fontFamily: 'Poppins',
                    fontSize: '20px',
                    lineHeight: '28px',
                    fontWeight: 700,
                    margin: '0',
                    transition: 'color 0.5s, background-color 0.5s',
                    color: '#B05DF1',
                    backgroundColor: 'white'
                }}
            >
                4
            </p>
        ),
        key: '4',
        subtitle: 'Frequently Concerned',
        orientation: 'horizontal'
    },
    {
        icon: (
            <p
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '40px',
                    height: '40px',
                    border: '2px solid #B05DF1',
                    borderRadius: '50%',
                    fontFamily: 'Poppins',
                    fontSize: '20px',
                    lineHeight: '28px',
                    fontWeight: 700,
                    margin: '0',
                    transition: 'color 0.5s, background-color 0.5s',
                    color: '#B05DF1',
                    backgroundColor: 'white'
                }}
            >
                5
            </p>
        ),
        key: '5',
        subtitle: 'Constantly Concerned',
        orientation: 'horizontal'
    },
];

export const FOCUS_AREAS: Choice[] = [
    {
        icon: null,
        key: 'frequency',
        title: 'Frequency',
        subtitle: 'Drink fewer days of the week.'
    },
    {
        icon: null,
        key: 'moderation',
        title: 'Moderation',
        subtitle: 'Have fewer drinks per typical drinking day.'
    },
    {
        icon: null,
        key: 'intensity',
        title: 'Intensity',
        subtitle: 'Avoid/eliminate unusually heavy drinking days.'
    },
    {
        icon: null,
        key: 'monitoring',
        title: 'Monitoring',
        subtitle: 'Keep tabs on my total consumption.'
    },
];

export const SEX_CHOICES: Choice[] = [
    {
        icon: null,
        key: 'Male',
        title: 'Male'
    },
    {
        icon: null,
        key: 'Female',
        title: 'Female'
    }
];

export const GENDER_CHOICES: Choice[] = [
    {
        icon: null,
        key: 'Male',
        subtitle: 'Male'
    },
    {
        icon: null,
        key: 'Female',
        subtitle: 'Female'
    },
    {
        icon: null,
        key: 'Other',
        subtitle: 'Other'
    },
    {
        icon: null,
        key: 'Anonymous',
        subtitle: 'Prefer Not to Say'
    }
];

export const PRONOUN_CHOICES: Choice[] = [
    {
        icon: null,
        key: 'He / Him',
        subtitle: 'He / Him'
    },
    {
        icon: null,
        key: 'She / Her',
        subtitle: 'She / Her'
    },
    {
        icon: null,
        key: 'They / Them',
        subtitle: 'They / Them'
    },
    {
        icon: null,
        key: 'Other',
        subtitle: 'Other'
    },
    {
        icon: null,
        key: 'Anonymous',
        subtitle: 'Prefer Not to Say'
    }
];

export const AGE_RANGES: Choice[] = [
    {
        icon: null,
        key: '21-25',
        subtitle: '21 - 25'
    },
    {
        icon: null,
        key: '26-30',
        subtitle: '26 - 30'
    },
    {
        icon: null,
        key: '31-35',
        subtitle: '31 - 35'
    },
    {
        icon: null,
        key: '36-40',
        subtitle: '36 - 40'
    },
    {
        icon: null,
        key: '41-45',
        subtitle: '41 - 45'
    },
    {
        icon: null,
        key: '46-55',
        subtitle: '46 - 55'
    },
    {
        icon: null,
        key: '56-65',
        subtitle: '56 - 65'
    },
    {
        icon: null,
        key: '65+',
        subtitle: '65+'
    },
];

export const DRY_JAN_CHALLENGES: Choice[] = [
    {
        icon: (
            <img
                src={'https://images.prismic.io/sunnysidetest/Z0DL0a8jQArT1OJN_DryJan2025-FullDry.png?auto=format,compress'}
                style={{
                    width: '32px',
                    height: 'auto'
                }}
            />
        ),
        key: 'Fully Dry',
        preferenceKey: 'full-dry',
        title: 'Fully Dry Challenge',
        subtitle: 'Try for no drinks over the course of the challenge',
        orientation: 'horizontal'
    },
    {
        icon: (
            <img
                src={'https://images.prismic.io/sunnysidetest/Z0DL1K8jQArT1OJR_DryJan2025-WeeknightDry.png?auto=format,compress'}
                style={{
                    width: '32px',
                    height: 'auto'
                }}
            />
        ),
        key: 'Week Night Dry',
        preferenceKey: 'no-drinks-sun-to-thu',
        title: 'Week Night Dry Challenge',
        subtitle: 'Try for no drinks Sunday through Thursday',
        orientation: 'horizontal'
    },
    {
        icon: (
            <img
                src={'https://images.prismic.io/sunnysidetest/Z0DL068jQArT1OJP_DryJan2025-Taper.png?auto=format,compress'}
                style={{
                    width: '32px',
                    height: 'auto'
                }}
            />
        ),
        key: 'Taper 30%',
        preferenceKey: 'generic-taper',
        title: 'Taper 30% Challenge',
        subtitle: 'Gradually reduce from baseline to 30% lower over course of challenge',
        orientation: 'horizontal'
    },
    {
        icon: (
            <img
                src={'https://images.prismic.io/sunnysidetest/Z0DL0K8jQArT1OJM_DryJan2025-Custom.png?auto=format,compress'}
                style={{
                    width: '32px',
                    height: 'auto'
                }}
            />
        ),
        key: 'Custom',
        preferenceKey: 'customize-weekly',
        title: 'Custom Challenge',
        subtitle: 'Create custom drink targets each week and work to achieve them',
        orientation: 'horizontal'
    },
];

export const DRY_JAN_2026_CHALLENGES: Choice[] = [
    {
        icon: (
            <img
                src={'https://images.prismic.io/sunnysidetest/aScvumGnmrmGqXO9_DryJan2026-FullDry.png?auto=format,compress'}
                style={{
                    width: '32px',
                    height: 'auto'
                }}
            />
        ),
        key: 'Fully Dry',
        preferenceKey: 'full-dry',
        title: 'Fully Dry Challenge',
        subtitle: 'Try for no drinks over the course of the challenge',
        orientation: 'horizontal'
    },
    {
        icon: (
            <img
                src={'https://images.prismic.io/sunnysidetest/aScvvWGnmrmGqXPA_DryJan2026-WeeknightDry.png?auto=format,compress'}
                style={{
                    width: '32px',
                    height: 'auto'
                }}
            />
        ),
        key: 'Week Night Dry',
        preferenceKey: 'no-drinks-sun-to-thu',
        title: 'Week Night Dry Challenge',
        subtitle: 'Try for no drinks Sunday through Thursday',
        orientation: 'horizontal'
    },
    {
        icon: (
            <img
                src={'https://images.prismic.io/sunnysidetest/aScvvGGnmrmGqXO__DryJan2026-Taper.png?auto=format,compress'}
                style={{
                    width: '32px',
                    height: 'auto'
                }}
            />
        ),
        key: 'Taper 30%',
        preferenceKey: 'generic-taper',
        title: 'Taper 30% Challenge',
        subtitle: 'Gradually reduce from baseline to 30% lower over course of challenge',
        orientation: 'horizontal'
    },
    {
        icon: (
            <img
                src={'https://images.prismic.io/sunnysidetest/aScvuWGnmrmGqXO7_DryJan2026-Custom.png?auto=format,compress'}
                style={{
                    width: '32px',
                    height: 'auto'
                }}
            />
        ),
        key: 'Custom',
        preferenceKey: 'customize-weekly',
        title: 'Custom Challenge',
        subtitle: 'Create custom drink targets each week and work to achieve them',
        orientation: 'horizontal'
    },
];

export const SOBERISH_MOM_DRYJAN_CHALLENGES: Choice[] = [
    {
        icon: (
            <img
                src={'https://images.prismic.io/sunnysidetest/Z04ISZbqstJ979n3_SoberishMom2025-FullDry.png?auto=format,compress'}
                style={{
                    width: '32px',
                    height: 'auto'
                }}
            />
        ),
        key: 'Fully Dry',
        preferenceKey: 'full-dry',
        title: 'Fully Dry Challenge',
        subtitle: 'Try for no drinks over the course of the challenge',
        orientation: 'horizontal'
    },
    {
        icon: (
            <img
                src={'https://images.prismic.io/sunnysidetest/Z04ITJbqstJ979n6_SoberishMom2025-WeeknightDry.png?auto=format,compress'}
                style={{
                    width: '32px',
                    height: 'auto'
                }}
            />
        ),
        key: 'Week Night Dry',
        preferenceKey: 'no-drinks-sun-to-thu',
        title: 'Week Night Dry Challenge',
        subtitle: 'Try for no drinks Sunday through Thursday',
        orientation: 'horizontal'
    },
    {
        icon: (
            <img
                src={'https://images.prismic.io/sunnysidetest/Z04IS5bqstJ979n5_SoberishMom2025-Taper.png?auto=format,compress'}
                style={{
                    width: '32px',
                    height: 'auto'
                }}
            />
        ),
        key: 'Taper 30%',
        preferenceKey: 'generic-taper',
        title: 'Taper 30% Challenge',
        subtitle: 'Gradually reduce from baseline to 30% lower over course of challenge',
        orientation: 'horizontal'
    },
    {
        icon: (
            <img
                src={'https://images.prismic.io/sunnysidetest/Z04ISJbqstJ979n2_SoberishMom2025-Custom.png?auto=format,compress'}
                style={{
                    width: '32px',
                    height: 'auto'
                }}
            />
        ),
        key: 'Custom',
        preferenceKey: 'customize-weekly',
        title: 'Custom Challenge',
        subtitle: 'Create custom drink targets each week and work to achieve them',
        orientation: 'horizontal'
    },
];

export const SOBERISH_MOM_DRYJAN_2026_CHALLENGES: Choice[] = [
    {
        icon: (
            <img
                src={'https://images.prismic.io/sunnysidetest/aSdGFGGnmrmGqXaT_SoberishMomDryJan2026-FullDry.png?auto=format,compress'}
                style={{
                    width: '32px',
                    height: 'auto'
                }}
            />
        ),
        key: 'Fully Dry',
        preferenceKey: 'full-dry',
        title: 'Fully Dry Challenge',
        subtitle: 'Try for no drinks over the course of the challenge',
        orientation: 'horizontal'
    },
    {
        icon: (
            <img
                src={'https://images.prismic.io/sunnysidetest/aSdGF2GnmrmGqXaW_SoberishMomDryJan2026-WeeknightDry.png?auto=format,compress'}
                style={{
                    width: '32px',
                    height: 'auto'
                }}
            />
        ),
        key: 'Week Night Dry',
        preferenceKey: 'no-drinks-sun-to-thu',
        title: 'Week Night Dry Challenge',
        subtitle: 'Try for no drinks Sunday through Thursday',
        orientation: 'horizontal'
    },
    {
        icon: (
            <img
                src={'https://images.prismic.io/sunnysidetest/aSdGFmGnmrmGqXaV_SoberishMomDryJan2026-Taper.png?auto=format,compress'}
                style={{
                    width: '32px',
                    height: 'auto'
                }}
            />
        ),
        key: 'Taper 30%',
        preferenceKey: 'generic-taper',
        title: 'Taper 30% Challenge',
        subtitle: 'Gradually reduce from baseline to 30% lower over course of challenge',
        orientation: 'horizontal'
    },
    {
        icon: (
            <img
                src={'https://images.prismic.io/sunnysidetest/aSdGE2GnmrmGqXaS_SoberishMomDryJan2026-Custom.png?auto=format,compress'}
                style={{
                    width: '32px',
                    height: 'auto'
                }}
            />
        ),
        key: 'Custom',
        preferenceKey: 'customize-weekly',
        title: 'Custom Challenge',
        subtitle: 'Create custom drink targets each week and work to achieve them',
        orientation: 'horizontal'
    },
];

export const SOBERISH_MOM_CHALLENGES: Choice[] = [
    {
        icon: (
            <img
                src={'https://images.prismic.io/sunnysidetest/Z5FmKpbqstJ99wbj_soberishmom-FullDry.png?auto=format,compress'}
                style={{
                    width: '32px',
                    height: 'auto'
                }}
            />
        ),
        key: 'Fully Dry',
        preferenceKey: 'full-dry',
        title: 'Fully Dry Challenge',
        subtitle: 'Try for no drinks over the course of the challenge',
        orientation: 'horizontal'
    },
    {
        icon: (
            <img
                src={'https://images.prismic.io/sunnysidetest/Z5FmLZbqstJ99wbo_soberishmom-WeeknightDry.png?auto=format,compress'}
                style={{
                    width: '32px',
                    height: 'auto'
                }}
            />
        ),
        key: 'Week Night Dry',
        preferenceKey: 'no-drinks-sun-to-thu',
        title: 'Week Night Dry Challenge',
        subtitle: 'Try for no drinks Sunday through Thursday',
        orientation: 'horizontal'
    },
    {
        icon: (
            <img
                src={'https://images.prismic.io/sunnysidetest/Z5FmLJbqstJ99wbm_soberishmom-Taper.png?auto=format,compress'}
                style={{
                    width: '32px',
                    height: 'auto'
                }}
            />
        ),
        key: 'Taper 30%',
        preferenceKey: 'generic-taper',
        title: 'Taper 30% Challenge',
        subtitle: 'Gradually reduce from baseline to 30% lower over course of challenge',
        orientation: 'horizontal'
    },
    {
        icon: (
            <img
                src={'https://images.prismic.io/sunnysidetest/Z5FmKZbqstJ99wbi_soberishmom-Custom.png?auto=format,compress'}
                style={{
                    width: '32px',
                    height: 'auto'
                }}
            />
        ),
        key: 'Custom',
        preferenceKey: 'customize-weekly',
        title: 'Custom Challenge',
        subtitle: 'Create custom drink targets each week and work to achieve them',
        orientation: 'horizontal'
    },
];

export const ZUMBA_CHALLENGES: Choice[] = [
    {
        icon: (
            <img
                src={'https://images.prismic.io/sunnysidetest/Z88QbBsAHJWomSt-_zumba-FullDry.png?auto=format,compress'}
                style={{
                    width: '32px',
                    height: 'auto'
                }}
            />
        ),
        key: 'Fully Dry',
        preferenceKey: 'full-dry',
        title: 'Fully Dry Challenge',
        subtitle: 'Try for no drinks over the course of the challenge',
        orientation: 'horizontal'
    },
    {
        icon: (
            <img
                src={'https://images.prismic.io/sunnysidetest/Z88QbxsAHJWomSuB_zumba-WeeknightDry.png?auto=format,compress'}
                style={{
                    width: '32px',
                    height: 'auto'
                }}
            />
        ),
        key: 'Week Night Dry',
        preferenceKey: 'no-drinks-sun-to-thu',
        title: 'Week Night Dry Challenge',
        subtitle: 'Try for no drinks Sunday through Thursday',
        orientation: 'horizontal'
    },
    {
        icon: (
            <img
                src={'https://images.prismic.io/sunnysidetest/Z88QbhsAHJWomSuA_zumba-Taper.png?auto=format,compress'}
                style={{
                    width: '32px',
                    height: 'auto'
                }}
            />
        ),
        key: 'Taper 30%',
        preferenceKey: 'generic-taper',
        title: 'Taper 30% Challenge',
        subtitle: 'Gradually reduce from baseline to 30% lower over course of challenge',
        orientation: 'horizontal'
    },
    {
        icon: (
            <img
                src={'https://images.prismic.io/sunnysidetest/Z88QaxsAHJWomSt9_zumba-Custom.png?auto=format,compress'}
                style={{
                    width: '32px',
                    height: 'auto'
                }}
            />
        ),
        key: 'Custom',
        preferenceKey: 'customize-weekly',
        title: 'Custom Challenge',
        subtitle: 'Create custom drink targets each week and work to achieve them',
        orientation: 'horizontal'
    },
];

export const BETTER_DRINKERS_CHALLENGES: Choice[] = [
    {
        icon: (
            <img
                src={'https://images.prismic.io/sunnysidetest/aEvELLNJEFaPX7wS_BetterDrinkers-Taper.png?auto=format,compress'}
                style={{
                    width: '32px',
                    height: 'auto'
                }}
            />
        ),
        key: 'Taper 30%',
        preferenceKey: 'generic-taper',
        title: 'Taper 30% Challenge',
        subtitle: 'Gradually reduce from baseline to 30% lower over course of challenge',
        orientation: 'horizontal'
    },
    {
        icon: (
            <img
                src={'https://images.prismic.io/sunnysidetest/aETvNbh8WN-LV4Ea_BetterDrinkers-WeeknightDry.png.png?auto=format,compress'}
                style={{
                    width: '32px',
                    height: 'auto'
                }}
            />
        ),
        key: 'Week Night Dry',
        preferenceKey: 'no-drinks-sun-to-thu',
        title: 'Week Night Dry Challenge',
        subtitle: 'Try for no drinks Sunday through Thursday',
        orientation: 'horizontal'
    },
    {
        icon: (
            <img
                src={'https://images.prismic.io/sunnysidetest/aETvMrh8WN-LV4EX_BetterDrinkers-FullDry.png.png?auto=format,compress'}
                style={{
                    width: '32px',
                    height: 'auto'
                }}
            />
        ),
        key: 'Fully Dry',
        preferenceKey: 'full-dry',
        title: 'Fully Dry Challenge',
        subtitle: 'Try for no drinks over the course of the challenge',
        orientation: 'horizontal'
    },
    {
        icon: (
            <img
                src={'https://images.prismic.io/sunnysidetest/aETvMbh8WN-LV4EW_BetterDrinkers-Custom.png?auto=format,compress'}
                style={{
                    width: '32px',
                    height: 'auto'
                }}
            />
        ),
        key: 'Custom',
        preferenceKey: 'customize-weekly',
        title: 'Custom Challenge',
        subtitle: 'Create custom drink targets each week and work to achieve them',
        orientation: 'horizontal'
    },
];

export const SOBERISH_OCTOBER_2025_CHALLENGES: Choice[] = [
    {
        icon: (
            <img
                src={'https://images.prismic.io/sunnysidetest/aMxHz2GNHVfTPYIj_SoberishOctober2025-FullDry.png?auto=format,compress'}
                style={{
                    width: '32px',
                    height: 'auto'
                }}
            />
        ),
        key: 'Fully Dry',
        preferenceKey: 'full-dry',
        title: 'Fully Dry Challenge',
        subtitle: 'Try for no drinks over the course of the challenge',
        orientation: 'horizontal'
    },
    {
        icon: (
            <img
                src={'https://images.prismic.io/sunnysidetest/aMxH0mGNHVfTPYIm_SoberishOctober2025-WeekNightDry.png?auto=format,compress'}
                style={{
                    width: '32px',
                    height: 'auto'
                }}
            />
        ),
        key: 'Week Night Dry',
        preferenceKey: 'no-drinks-sun-to-thu',
        title: 'Week Night Dry Challenge',
        subtitle: 'Try for no drinks Sunday through Thursday',
        orientation: 'horizontal'
    },
    {
        icon: (
            <img
                src={'https://images.prismic.io/sunnysidetest/aMxH0WGNHVfTPYIl_SoberishOctober2025-Taper.png?auto=format,compress'}
                style={{
                    width: '32px',
                    height: 'auto'
                }}
            />
        ),
        key: 'Taper 30%',
        preferenceKey: 'generic-taper',
        title: 'Taper 30% Challenge',
        subtitle: 'Gradually reduce from baseline to 30% lower over course of challenge',
        orientation: 'horizontal'
    },
    {
        icon: (
            <img
                src={'https://images.prismic.io/sunnysidetest/aMxHzmGNHVfTPYIi_SoberishOctober2025-Custom.png?auto=format,compress'}
                style={{
                    width: '32px',
                    height: 'auto'
                }}
            />
        ),
        key: 'Custom',
        preferenceKey: 'customize-weekly',
        title: 'Custom Challenge',
        subtitle: 'Create custom drink targets each week and work to achieve them',
        orientation: 'horizontal'
    },
];

export type DiagnosticAnswers = {
    your_name?: string,
    caloriesAvoided?: string,
    dollarsSaved?: string,
    extraNightsOfSleep?: string,
    targetTotalDrinks?: number,
    targetTotalDryDays?: number,
    totalDrinksBaseline?: number,
    totalDryDaysBaseline?: number,
    top_goal?: string,
    other_goals?: string[],
    endGoal?: string,
    email?: string,
    mon_baseline?: number,
    tue_baseline?: number,
    wed_baseline?: number,
    thu_baseline?: number,
    fri_baseline?: number,
    sat_baseline?: number,
    sun_baseline?: number,
    drinkCost?: number,
    freq_of_effects?: string,
    concern_level?: number,
    focus_areas?: string[],
    gender?: string,
    pronouns?: string,
    age_range?: string,
    customTargets?: string,
    
    ideal_outcome?: string,
    negative_consequences?: string,
    challenge_controlling?: string,
    height?: string,
    weight?: string,
    state?: string,
    recommendedPlanKey?: string
    chosenPlanKey?: MEDICATION_PLAN_KEY
};
